import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'components/CustomButtons/Button.js';
import Warning from '@material-ui/icons/Warning';

const useStyles = makeStyles({
    dialogPaper: {
        width: '450px',
        height: '325px',
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        textAlign: 'center',
    },
    content: {
        flex: '1 1 auto',
        textAlign: 'center',
        padding: '0 24px 20px',
    },
    icon: {
        color: '#ffa726',
        fontSize: '8rem',
        display: 'block',
        margin: '0 auto',
        padding: '16px 0',
    },
});

const CancelBookingDialog = ({ open, onClose, onConfirm }) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="confirm-cancel-dialog-title"
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogTitle id="confirm-cancel-dialog-title" className={classes.title}>
                Confirm Cancellation
            </DialogTitle>

            <DialogContent className={classes.content}>
                <Warning className={classes.icon} />
                <p>Please confirm that you want to cancel this booking</p>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="transparent">
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="rose" autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CancelBookingDialog;